import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import { AddFBRProductApi } from "./FBRProductAction";
import { GetFBRCompanyApi } from "../FBRCompany/FBRCompanyAction";
import { setHeading } from "../../../accounts/account.actions";
import { Button } from "@mui/material";
import Select from "react-select";
import SendIcon from "@mui/icons-material/Send";


const FBRAddProduct = (props) => {
    const initialFormState = {
        name: "",
        unitPrice: "",
        saleTax: "",
        extraTax: "",
        HSCode: "",
    };
    const [form, setForm] = useState(initialFormState);
    const [companyId, setCompanyId] = useState("");
    const [companyName, setCompanyName] = useState("");

    useEffect(() => {
        props.setHeading("Add Product");
        props.GetFBRCompanyApi()
    }, []);

    const handleChange = (field) => (e) => {
        setForm({ ...form, [field]: e.target.value });
    };

    function SaveProduct() {
        props.AddFBRProductApi({
            ...form,
            companyId,
            companyName,
        },
            showSuccessAlert,
            showErrorAlert
        );
        setForm(initialFormState);
        setCompanyId("");
        setCompanyName("");
    }

    const handleChangeCompany = (selectedOption) => {
        setCompanyId(selectedOption.value);
        setCompanyName(selectedOption.label);
    };
    const CompanyList = props.FBRCompanyDataList?.length ? props.FBRCompanyDataList.map(x => ({
        value: x._id,
        label: x.companyName
    })) : [];


    return (
        <>
            {props.isAddingFBRProduct || props.isFetchingFBRCompany ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Form>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Select Company *</b></Form.Label>
                                    <Select
                                        // placeholder="Select Company"
                                        onChange={handleChangeCompany}
                                        options={CompanyList}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Product Name *</b></Form.Label>
                                    <Form.Control
                                        // placeholder="Product Name"
                                        onChange={handleChange("name")}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>HS Code *</b></Form.Label>
                                    <Form.Control
                                        value={form.HSCode}
                                        onChange={handleChange("HSCode")}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Unit Price *</b></Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={form.unitPrice}
                                        onChange={handleChange("unitPrice")}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Sale's Tax *</b></Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={form.saleTax}
                                        onChange={handleChange("saleTax")}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana">
                                    <Form.Label><b>Extra Tax *</b></Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={form.extraTax}
                                        onChange={handleChange("extraTax")}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <div className="sendDiv" >
                            <Button variant="contained" endIcon={<SendIcon />} size="large"
                                disabled={isEmpty(form.name)}
                                onClick={SaveProduct}
                            >
                                SAVE
                            </Button>
                        </div>

                    </Form>
                </Container>
            )}
        </>
    );
};

const mapDispatchToProps = (dispatch) => ({
    AddFBRProductApi: (data, success, error) => dispatch(AddFBRProductApi(data, success, error)),
    GetFBRCompanyApi: () => dispatch(GetFBRCompanyApi()),
    setHeading: (data) => dispatch(setHeading(data)),
});

const mapStateToProps = (state) => ({
    isAddingFBRProduct: state.FBRProductReducer.isAddingFBRProduct,
    isFetchingFBRCompany: state.FBRCompanyReducer.isFetchingFBRCompany,
    FBRCompanyDataList: state.FBRCompanyReducer.FBRCompanyDataList,
});

export default connect(mapStateToProps, mapDispatchToProps)(FBRAddProduct);